// import { console } from "inspector";

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$("button.Collapsible__Button").click(function(){$(this).parents('.Collapsible').siblings().children('button.Collapsible__Button').removeClass('active_tab');$(this).toggleClass('active_tab');});
$('document').ready (function(){
    selecttag();
});
function selecttag(){
    $('button[data-action="toggle-tag"]').on('click',function(){
        var currenttagname = $(this).text();
        var currentdatatagname = $(this).attr('data-tag');
        var currentdatatagnamenew = currentdatatagname.split("_"); 
        var currentdatatagnamenew = currentdatatagnamenew[0];
        var currentdatatagnamenew = currentdatatagnamenew.toLowerCase();
        var currentclassname = $('body ul#select-filter-list li' + '.' + currentdatatagnamenew );
        if($('body ul#select-filter-list').find('li').hasClass(currentdatatagnamenew)){
            if($(this).hasClass('is-active')){
                $(currentclassname).remove();
            }
            else{
                $(currentclassname).text();
                $(currentclassname ).text(currenttagname);
            }
        }
        else{
            $('body ul#select-filter-list').append(
                '<li class=' + '"' + currentdatatagnamenew + '"' + '>'+ currenttagname + '</li>');
        }
    });
    $('button[data-action="reset-tags"]').on('click',function(){
      $('body #select-filter-list').empty();
    });
    $('.close-current-filter').on('click',function(){
        $(this).parent('li').remove();
    });
}
function variantplp(el) {  
    // alert( this.value );
    var url=$(el).attr('option_url'),
    img_url=$(el).attr('img_url');
    // console.log(img_url,'ursel',url);
    if(img_url != undefined){ $(el).closest('.ProductItem__Wrapper').find('img.ProductItem__Image').attr('src',img_url);}
    $(el).closest('.ProductItem__Wrapper').find('.customurl').attr('href',url);
    $(el).closest('.ProductItem__Wrapper').children('a').attr('href',url);
}


// price update function
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

 function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();

  function _updateProductPrice() {
    console.log('in update price');
    var finalPrice = parseFloat(document.querySelector('.sub-toatal-fixed-bottom-part .s-t-f-b-p-price').getAttribute("data-mainprice")),
        currencyFormat = window.themeVariables.currencyCodeEnabled ? window.themeVariables.moneyWithCurrencyFormat : window.themeVariables.moneyFormat;
    Array.from(document.querySelectorAll('.d-o-p-s-content-body .d-o-p-s-radio-opt .input-radio-opt')).forEach(function(Isrequired) {
        var ChildQuantity = 0,
        ChildPrice = 0;
        
        if (Isrequired.type == 'radio' && Isrequired.checked) {
          ChildQuantity = parseInt(1);
          ChildPrice = Isrequired.getAttribute('data-product-price');
        } else if (Isrequired.type == 'select-one') {
          var selected_value = Isrequired;
          let selectedProPrice = Isrequired.selectedOptions[0].getAttribute("data-product-price");
          ChildQuantity = parseInt(1);
          ChildPrice = selectedProPrice;
        }
        ChildPrice = ChildQuantity * ChildPrice;
        finalPrice = finalPrice + parseFloat(ChildPrice);
      });
    var formatedChildPrice = Currency.formatMoney(finalPrice, currencyFormat);
    document.querySelector('.sub-toatal-fixed-bottom-part .s-t-f-b-p-price').innerHTML = formatedChildPrice;
  }

  window.onload = function(){
    var elements = document.getElementsByClassName('input-radio-opt');    
    for (var i=0;i<elements.length;i++) {
      elements[0].click();
      elements[0].checked = true;
    }
    _updateProductPrice();
  }

jQuery(document).ready(function() {
  $('.dopsTabContent').hide();
  $('.dopsTabContent:first-child').show();

  // next and pervious step js code
  $('.steps ul > li > a').click(function(e) {
    e.preventDefault(); // Prevent default anchor link behavior
    // Determine the target tab content using a custom data attribute
    var targetTab = $(this).data('target'); // Assumes a data-target attribute on the link

    $('.dopsTabContent').hide();
    $('.steps ul > li').removeClass('active-step');

    $('.steps ul > li > a[data-target="' + targetTab + '"]').closest('li').not('li.has-inlay-false').addClass('active-step');

    $(this).closest('li').addClass('active-step').removeClass('next-step');
    $(targetTab).show(); // Show the target tab content

    // Check if the event target is a radio button or a select dropdown for the ring size selection step
    let ringSizeSelectBox;
    if ($(targetTab).find('.ring-size-body').length > 0 ) {
      if ($(targetTab).find('select[name="ring-size-opt"]')) {
          ringSizeSelectBox = $(targetTab).find('.input-radio-opt').closest('.d-o-p-s-radio-opt:not(.d-none)').first(); // Get the selected option if it's a dropdown
          ringSizeSelectBox.find('.input-radio-opt').prop('selectedIndex', 0).trigger('change');
      }
    } else {
        ringSizeSelectBox = $(targetTab).find('.input-radio-opt').closest('.d-o-p-s-radio-opt:not(.d-none)').first(); // Get the checked radio button
        ringSizeSelectBox.find('.input-radio-opt').click();
        ringSizeSelectBox.find('.input-radio-opt').checked = true;
    }

    // back step js code
    $('.sub-toatal-fixed-bottom-part .steps .step').removeClass('back-step');
    var prevLi = $('.sub-toatal-fixed-bottom-part .steps ul .step > a[data-target="' + targetTab + '"]').closest('li.step').prev('li');
    if(prevLi.hasClass('d-none') || prevLi.hasClass('bottom-nav-add-to-cart-btn')){
      if (prevLi.hasClass('has-inlay-false')) {
        if (prevLi.prev('li').hasClass('d-block')) {
          prevLi.prev('li').addClass('back-step');          
        } else if (prevLi.prev('li').hasClass('d-block')) {
          prevLi.prev('li').prev('li').addClass('back-step');          
        } else {
          prevLi.prev('li').prev('li').prev('li').addClass('back-step');
        }
      } else {
        prevLi.prev('li').addClass('back-step');
      }
    } else {
      prevLi.addClass('back-step');
    }

    // next step js code
    $('.sub-toatal-fixed-bottom-part .steps .step').removeClass('next-step');
    var nextLi = $('.sub-toatal-fixed-bottom-part .steps ul .step > a[data-target="' + targetTab + '"]').closest('li.step').next('li');
    if(nextLi.hasClass('d-none') || nextLi.hasClass('bottom-nav-add-to-cart-btn')){
      if (nextLi.hasClass('has-inlay-false')) {
        if (nextLi.next('li').hasClass('d-block')) {
          nextLi.next('li').addClass('next-step');          
        } else if (nextLi.next('li').next('li').hasClass('d-block')) {
          nextLi.next('li').next('li').addClass('next-step');
        }else {
          nextLi.next('li').next('li').next('li').addClass('next-step');
        }
      } else {
        nextLi.next('li').addClass('next-step');
      }
    } else {
      nextLi.addClass('next-step');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    $('.design-own-product-steps #step1 > .steps .step').removeClass('fill-step');
    $('.design-own-product-steps #step1 > .steps ul .step > a[data-target="' + targetTab + '"]').closest('li').prevAll('li').addClass('fill-step');
    
  });

});

$(function() {  
  $('.step-wrap').click(function() {
      if ($('.bottom-nav-add-to-cart-btn').hasClass('d-block')) {
        $('.bottom-nav-add-to-cart-btn').removeClass('d-block');
      }

      if ($('.bottom-nav-add-to-cart-btn button').hasClass('hide')) {
        $('.bottom-nav-add-to-cart-btn button').removeClass('hide');
      }
  });
});

$(document).ready(function() {
    $(".product-additional-info-tab-nav li a").click(function(e) {
        e.preventDefault();
        $(this).closest('li').siblings('li.p-a-i-tab-active').removeClass("p-a-i-tab-active");
        $(this).closest('li').addClass("p-a-i-tab-active");
        var index = $(this).closest('li').index();
        $(".p-a-i-tab-content").removeClass("p-a-i-content-active");
        $(".p-a-i-tab-content").eq(index).addClass("p-a-i-content-active");
    });

  // custom page
  
  $('.CollectionList a').on('click', function(event){
    event.preventDefault();
    let collection = $(this).attr('href');
    if(collection.indexOf('/pages/mens-custom-ring') > -1 ){
      window.location.href = collection;
      return true;
    } else if(collection.indexOf('/pages/women-stone-custom-ring') > -1 ){
      window.location.href = collection;
      return true;
    } else {
      let parentDiv = $(this).closest('.datasteps');
      parentDiv.hide();
      parentDiv.next().show();
      return false;        
    }
  });

  function slickCenterSton() {
    $('.center-stone-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'ease-in-out',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 3000
    });
  }
  function slickRingStep() {
    $('.ring-step-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'ease-in-out',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 3000
    });
  }

  $('.dopsTabContent').on('change', '.d-o-p-s-radio-opt', function(){
    
    let currentTarget = $(this);
    let nextStep = $('.datasteps .step.active-step').next();
    let prevstep = $('.datasteps .step.active-step').prev();

    let parentDiv = $(this).closest('.dopsTabContent');
    let parentSelectedOption = parentDiv.prev().find('input[type="radio"]:checked');

    let currentOption;

    // // Check if the event target is a radio button or a select dropdown
    if ($(this).find('select[name="ring-size-opt"]').length > 0 ) {
        currentOption = $(this).find('select[name="ring-size-opt"]'); // Get the selected option if it's a dropdown
    } else {
      currentOption = $(this).find('input[type="radio"]:checked'); // Get the checked radio button
    }
    
    // let currentOption = $(this).find('input[type="radio"]:checked');

    let hasCenterStone, hasAccentStone, inlayCount, inlayCount1, inlayCount2, inlayCount3, hasFinish, has8mm, ringAccentStoneTag, noEngraving;
    
     if(currentOption.attr('name') == 'choose-ring-opt'){
      var chooseRingimg = currentOption.next().attr('src');
      $('.main_choose_ring_img').attr('src',chooseRingimg);
      _updateProductPrice();
      
      // Mobile-specific image slider injection
      if (window.innerWidth <= 767) {
        const productUrl = currentOption.data('product-url');

        $.getJSON(productUrl + '.js', function (product) {
          const images = product.images;
          if (images.length > 0) {
            const sliderHtml = `<div class="mobile-ring-slider">` +
              images.map(img => `<div class="slider-item"><img src="${img}" alt="ring slide" /></div>`).join('') +
              `</div>`;

            const $optionWrapper = currentOption.closest('.d-o-p-s-radio-opt');

            // Remove previous sliders and reset hidden images
            $('.d-o-p-s-radio-opt .mobile-ring-slider').remove();
            $('.d-o-p-s-radio-opt img.product_img').show();

            // Hide static image in current option
            $optionWrapper.find('img.product_img').hide();

             // Inject slider before the image
            $optionWrapper.find('img.product_img').before(sliderHtml);
            $optionWrapper.find('.mobile-ring-slider').addClass('loading-slider');

            setTimeout(() => {
              $optionWrapper.find('.mobile-ring-slider').slick({
                dots: false,
                arrows: true,
                fade: true,
                cssEase: 'ease-in-out',
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 1,
                adaptiveHeight: true
              });
              $optionWrapper.fadeIn(200);
              $optionWrapper.find('.mobile-ring-slider').removeClass('loading-slider');
            }, 100);
          }
        });
      }
      

      // get selected product variants and store in the localstorage
      var productUrl = currentOption.data('product-url');
      var product_tags, arraycontain8mm, arrayContainFinish;
      jQuery.getJSON(productUrl + '.js', function(product) {
        var productVariants = product.variants;
        product_tags = product.tags
        arraycontain8mm = (product_tags.indexOf("Only 8mm") > -1);
        arrayContainFinish = (product_tags.indexOf("Finish Available") > -1);
        // console.log(arraycontain8mm, '=======>arraycontain8mm');
        // console.log(product_tags, '=======>product');
        var productVariantsJson = JSON.stringify(productVariants);
        // Store the JSON string in localStorage
        localStorage.setItem('productVariants', productVariantsJson);

        
        const images = product.images; // Array of image URLs
        if (images.length > 0) {
            // Create slider content
            const sliderContent = images.map((image, index) => `
                <div class="slider-item">
                    <img src="${image}" alt="Ring Image ${index + 1}" />
                </div>
            `).join('');

            // Update main_center_stone_img div
            const $mainDiv = $('.ring_step_img');
            $mainDiv.addClass('loading-slider');

            // Destroy existing Slick instance if initialized
            if ($mainDiv.find('.ring-step-slider').hasClass('slick-initialized')) {
              $mainDiv.find('.ring-step-slider').slick('unslick');
            }

            // $mainDiv.html(`<div class="ring-step-slider">${sliderContent}</div>`);
            $mainDiv.html(`<div class="ring-step-slider" style="display:none;">${sliderContent}</div>`);
            // Initialize Slick Slider
            setTimeout(() => {
              slickRingStep();
              $mainDiv.find('.ring-step-slider').fadeIn(200); // smooth reveal
              $mainDiv.removeClass('loading-slider');
            }, 100);
            
        } else {
            console.error('No images available for the selected center stone.');
        }
      }).fail(function () {
          console.error('Failed to fetch product data.');
      });      
      
      // Function to get the product variants from localStorage
      setTimeout(() => {
        
      // console.log(arraycontain8mm, '=======> out loop arraycontain8mm');
      // console.log(product_tags, '=======>out loop producttags');
        function getProductVariants() {
          var retrievedProductVariantsJson = localStorage.getItem('productVariants');
          if (retrievedProductVariantsJson) {
              return JSON.parse(retrievedProductVariantsJson);
          }
          return null;
        }

        // Example usage: Retrieve the product variants from localStorage
        var retrievedProductVariants = getProductVariants();
        if (retrievedProductVariants) {
            
            if ($(".band_color_section .basematerial-wrapper").length > 0 ) {
              $(".band_color_section .basematerial-wrapper").html("");
              Array.from(retrievedProductVariants).forEach(function(retrievedVariants, index) {
                var currencyFormat = window.themeVariables.currencyCodeEnabled ? window.themeVariables.moneyWithCurrencyFormat : window.themeVariables.moneyFormat;
                var forloopindex = index + 1;
                var variantTitle = retrievedVariants.title;
                var variantPrice = retrievedVariants.price;
                var variantProductName = retrievedVariants.name;
                var variantID = retrievedVariants.id;
                var formatedVariantPrice = Currency.formatMoney(variantPrice, currencyFormat);
                var variantImage = retrievedVariants.featured_image;
                let selectedVariantImage;
                if(variantImage != null) {
                  selectedVariantImage = variantImage.src;
                } else {
                  selectedVariantImage = 'https://cdn.shopify.com/s/files/1/0252/9588/0271/files/StagheadFullcolorgradientB_Wlettering_stacked_1fdedab1-fcc0-483d-be07-b44d1cd1072e.jpg?v=1711407479';
                }

                var varianthtml = `<div class="Grid__Cell 1/4--lap-and-up 1/2--tablet band-color-box d-o-p-s-radio-opt">
                  <input type="radio" id="band-c-${forloopindex}" class="input-radio-opt" name="band-color-opt" data-hide-bandwidth="${arraycontain8mm}" data-hide-finishstep="${arrayContainFinish}"
                  data-color-name="${variantTitle}" data-product-price="${variantPrice}" data-product-name='${variantTitle}' data-variant-id="${variantID}" data-product-name='${variantTitle}' value="${variantTitle}">
                  <img src="${selectedVariantImage}"  data-src="${selectedVariantImage}" width="100%" height="100%" alt="${variantTitle}">
                  <label for="band-c-${forloopindex}">${variantTitle}</label>
                  <div class="d-o-p-s-product-price" data-product-price="${variantPrice}">+${formatedVariantPrice}</div>
                  </div>`;

                  document.querySelector(".band_color_section .basematerial-wrapper").insertAdjacentHTML(
                    'beforeend', 
                    varianthtml
                  );
                
              });
            }
        } else {
            console.log('No product variants found in localStorage');
        }
      }, 1000);

       
      // hide show Accent stone porduct from women's option based on the accent ston products tag on Ring products
       ringAccentStoneTag = currentOption.data('ringaccenttag');
       $('.accent_stone_wrapper .accent-stone-box').each(function() {
        var accentStoneProductTag = $(this).data('accent-tag');
        if (accentStoneProductTag == ringAccentStoneTag ) {
          $(this).addClass('d-inline-block').removeClass('d-none');
          $(this).click();
        } else {
          $(this).addClass('d-none').removeClass('d-inline-block');
          $(this).find('input[name="choose-accent-stone"]').prop('checked', false);
        }
      });
      
       
      // hide show bandwidth prduct option based on the 'Only 8mm' tag on Ring products
      has8mm = currentOption.data('8mmbandwidth');
      if(has8mm != undefined) {
        if (has8mm == 'yes') {
          $('.bandWidthProductPart').addClass('d-none has-inlay-false').removeClass('d-block has-inlay-true');
          $('.band_width_section').removeClass('dopsTabContent');
          $('input[name="choose-bandwidth-opt"]').prop('checked', false);
        } else {
          $('.bandWidthProductPart').addClass('d-block has-inlay-true').removeClass('d-none has-inlay-false');
          $('.band_width_section').addClass('dopsTabContent');
        }
      }

      // hide/show inlay 2 prduct option based on the 'Has 2 Inlays' tag on Ring products
      inlayCount1 = currentOption.data('inlaycount1');
      inlayCount2 = currentOption.data('inlaycount2');
      inlayCount3 = currentOption.data('inlaycount3');
       
      if(inlayCount2 != undefined) {
        if (inlayCount2 == 'no') {
          // console.log('in if inlay 2');
          $('.inplayProductPart2 ').addClass('d-none has-inlay-false').removeClass('d-block has-inlay-true');
          $('.inlay_product_section2 ').removeClass('dopsTabContent');
          $('input[name="choose-inlay-opt-2"]').prop('checked', false);

          $('.inplayProductPart3 ').addClass('d-none has-inlay-false').removeClass('d-block has-inlay-true');
          $('.inlay_product_section3 ').removeClass('dopsTabContent');
          $('input[name="choose-inlay-opt-3"]').prop('checked', false);
        } else {
          $('.inplayProductPart2').addClass('d-block has-inlay-true').removeClass('d-none has-inlay-false');
          $('.inlay_product_section2 ').addClass('dopsTabContent');
        }
      }
       
       
      // hide/show inlay 3 prduct option based on the 'Has 3 Inlays' tag on Ring products
      if(inlayCount3 != undefined) {
        if (inlayCount3 == 'no') {
          $('.inplayProductPart3 ').addClass('d-none has-inlay-false').removeClass('d-block has-inlay-true');
          $('.inlay_product_section3 ').removeClass('dopsTabContent');
          $('input[name="choose-inlay-opt-3"]').prop('checked', false);
        } else {
          $('.inplayProductPart2').addClass('d-block has-inlay-true').removeClass('d-none has-inlay-false');
          $('.inlay_product_section2 ').addClass('dopsTabContent');
          
          $('.inplayProductPart3').addClass('d-block has-inlay-true').removeClass('d-none has-inlay-false');
          $('.inlay_product_section3 ').addClass('dopsTabContent');
        }
      }

       
      // hide show finish prduct option based on the 'Finish Available' tag on Ring products
      hasFinish = currentOption.data('finish');
      if(hasFinish != undefined) {
        if (hasFinish == 'no') {
          $('.finishpart ').addClass('d-none').removeClass('d-block');
          $('.finish_section ').removeClass('dopsTabContent');
          $('input[name="choose-finish-opt"]').prop('checked', false);
        } else {
          $('.finishpart ').addClass('d-block').removeClass('d-none');
          $('.finish_section ').addClass('dopsTabContent');
        }
      }
       

      // hide show engraving prduct option based on the 'Non-Engravable' tag on Ring products
      noEngraving = currentOption.data('no-engraving');
      if(noEngraving != undefined) {
        if (noEngraving == true) {
          $('.engravingsPart').addClass('d-none has-inlay-false').removeClass('d-block has-inlay-true');
          $('.engraving_section').removeClass('dopsTabContent');
          $('input[name="choose-engravings-opt"]').prop('checked', false);
          $('input[name="choose-ring-box-engravings-opt"]').prop('checked', false);
        } else {
          $('.engravingsPart').addClass('d-block has-inlay-true').removeClass('d-none has-inlay-false');
          $('.engraving_section').addClass('dopsTabContent');
        }
      }
       
      // hide show centerstone option based on the center tag products
      hasCenterStone = currentOption.data('centerstone');
      if(hasCenterStone != undefined) {
        if (hasCenterStone == 'yes') {
          $('.centerStonePart').addClass('d-none').removeClass('d-block');
          $('.center-stone-section').removeClass('dopsTabContent');
          $('input[name="choose-center-stone"]').prop('checked', false);
        } else {
          $('.centerStonePart').addClass('d-block').removeClass('d-none');
          $('.center-stone-section').addClass('dopsTabContent');
        }
      }
       
      // hide show Accent stone option based on the center tag products
      hasAccentStone = currentOption.data('accentstone');
      if(hasAccentStone != undefined){
        if (hasAccentStone == 'yes') {
          $('.accentStonePart').addClass('d-none has-inlay-false').removeClass('d-block has-inlay-true');
          $('.accent-stone-section').removeClass('dopsTabContent');
          $('input[name="choose-accent-stone"]').prop('checked', false);
        } else {
          $('.accentStonePart').addClass('d-block has-inlay-true').removeClass('d-none has-inlay-false');
          $('.accent-stone-section').addClass('dopsTabContent');
        }
      }
      
    } else if(currentOption.attr('name') == 'band-color-opt'){
      var bandColorimg = currentOption.next().attr('src');
      $('.main_band_color_img').attr('src',bandColorimg);
      _updateProductPrice();

       var selectedBandVariant = currentOption.val();
       var bandWidthValue = currentOption.data('hide-bandwidth');
       var finishValue = currentOption.data('hide-finishstep');
       
       

       currentOption.prop('checked', true);
       if(selectedBandVariant == '14K Yellow Gold' || selectedBandVariant == '14K Rose Gold' || selectedBandVariant == '14K White Gold') {
          if (bandWidthValue != true) {
            $('.gold_8mm_width').addClass('d-inline-block').removeClass('d-none');
            $('.8mm_width').addClass('d-none').removeClass('d-inline-block');
            $('.8mm_width').next('input[name="choose-bandwidth-opt"]').prop('checked', false);
          }
          if (finishValue != false) {
            $('.finishpart ').addClass('d-block').removeClass('d-none');
            $('.finish_section ').addClass('dopsTabContent');
          }
       } else if (selectedBandVariant.includes('Tungsten') || selectedBandVariant.includes('Damascus Steel')) {
          $('.finishpart').addClass('d-none').removeClass('d-block');
          $('.finish_section ').removeClass('dopsTabContent');
          $('input[name="choose-finish-opt"]').prop('checked', false);
          if (bandWidthValue != true) {
            $('.gold_8mm_width').addClass('d-none').removeClass('d-inline-block');
            $('.8mm_width').addClass('d-inline-block').removeClass('d-none');
            $('.gold_8mm_width').next('input[name="choose-bandwidth-opt"]').prop('checked', false);
          }
      } else {
          if (bandWidthValue != true) {
            $('.gold_8mm_width').addClass('d-none').removeClass('d-inline-block');
            $('.8mm_width').addClass('d-inline-block').removeClass('d-none');
            $('.bandWidthProductPart').addClass('d-block').removeClass('d-none');
            $('.band_width_section').addClass('dopsTabContent');
            $('.gold_8mm_width').next('input[name="choose-bandwidth-opt"]').prop('checked', false);
          }
          $('.finishpart ').addClass('d-block').removeClass('d-none');
          $('.finish_section ').addClass('dopsTabContent');
       }

       
      $('.finish-wrapper .finish-option-box').each(function() {
        var finish_name = $(this).data('finish-name');
        if (selectedBandVariant == 'Damascus Steel' && finish_name == 'Hammered' ) {
          $(this).addClass('d-none').removeClass('d-inline-block');
        } else if (selectedBandVariant == 'Damascus Steel' && finish_name == 'Brushed' ) {
          $(this).addClass('d-none').removeClass('d-inline-block');
        } else {
          $(this).addClass('d-inline-block').removeClass('d-none');
        }
      });
       
    } else if(currentOption.attr('name') == 'choose-inlay-opt'){
      _updateProductPrice();
      var inlayProductimg = currentOption.next().attr('src');
      $('.main_inlay_product_img').attr('src',inlayProductimg);
      if (currentOption.val() == 'Send in my own materials') {
        $('.own-material-info-wrapper').show();
      } else {
        $('.own-material-info-wrapper').hide();
        $('.own-material-info-wrapper textarea[name="inlay-material-info"]').val('');
      }
    } else if(currentOption.attr('name') == 'choose-inlay-opt-2'){
      _updateProductPrice();
      var inlayProductimg2 = currentOption.next().attr('src');
      $('.main_inlay_product_img2').attr('src',inlayProductimg2);
      if (currentOption.val() == 'Send in my own materials') {
        $('.own-material-info-wrapper').show();
      } else {
        $('.own-material-info-wrapper').hide();
        $('.own-material-info-wrapper textarea[name="inlay-material-info-2"]').val('');
      }
    } else if(currentOption.attr('name') == 'choose-inlay-opt-3'){
      _updateProductPrice();
      var inlayProductimg3 = currentOption.next().attr('src');
      $('.main_inlay_product_img3').attr('src',inlayProductimg3);
      if (currentOption.val() == 'Send in my own materials') {
        $('.own-material-info-wrapper').show();
      } else {
        $('.own-material-info-wrapper').hide();
        $('.own-material-info-wrapper textarea[name="inlay-material-info-3"]').val('');
      }
    }  else if(currentOption.attr('name') == 'choose-engravings-opt'){
      _updateProductPrice();
       
      var engravingProductimg = currentOption.next().attr('src');
      $('.main_engravings_product_img').attr('src',engravingProductimg);
      if (currentOption.val() == 'Image Engraving') {
        $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
        $('.image-engraving-info-wrapper').show();
        $('.text-engraving-info-wrapper').hide();
        $('.text-engraving-info-wrapper .text_engraving').val('');
        $('#image-engraving-info').prop('required', true);
        $('#text-engraving-info').prop('required', false);
        // enable disable view ring based on image is uploaded or not
        $("#image-engraving-info").change(function() {            
          if ($(this).prop("files").length > 0) {
            $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
          } else {
            $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
          }
        });

        
      } else if(currentOption.val() == 'Text Engraving'){
        $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
        $('.text-engraving-info-wrapper').show();
        $('.image-engraving-info-wrapper').hide();
        $('.image-engraving-info-wrapper .image_engraving').val('');
        $('#image-engraving-info').prop('required', false);
        $('#text-engraving-info').prop('required', true);
        // enable disable view ring based on text is added or not
          $("#text-engraving-info").keyup(function() {
            var hasText = $(this).val().trim() !== ""; // Check for non-empty trimmed value
            if (hasText) {
              $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable"); // Replace "your-class-name" with your desired class
            } else {
              $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
            }
          });
      } else {
        $('.image-engraving-info-wrapper').hide();
        $('.text-engraving-info-wrapper').hide();
        $('.image-engraving-info-wrapper .image_engraving').val('');
        $('.text-engraving-info-wrapper .text_engraving').val('');
        $('#image-engraving-info').prop('required', false);
        $('#text-engraving-info').prop('required', false);
        
        
        var checkedRingboxEngravingOption = $( "#ring-box-engraving-info option:selected" ).val();        
        if(checkedRingboxEngravingOption == 'Text') {
          if ($('#ring-box-text-engraving-info').val() != '') {
            $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
          } else {
            $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
          }
        } else if(checkedRingboxEngravingOption == 'Image') {
          if ($('#image-engraving-info').val() != '') {
            $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
          } else {
            $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
          }
        } else {
          $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
        }
      }
      
    } else if(currentOption.attr('name') == 'choose-ring-box-engravings-opt'){
      _updateProductPrice();
      if(currentOption.val() == 'Ring Box Engraving'){
        $('.ring-box-engraving-info-wrapper').show();
        $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
      } else {
        $('.ring-box-engraving-info-wrapper').hide();
        $("#ring-box-engraving-info").val('Choose Text Or Image Engraving').change();
        
        var checkedEngravingOption = $('input[name="choose-engravings-opt"]:checked').val();
        if(checkedEngravingOption == 'Text Engraving') {
          if ($('#text-engraving-info').val() != '') {
            $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
          } else {
            $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
          }
        } else if(checkedEngravingOption == 'Image Engraving') {
          if ($('#image-engraving-info').val() != '') {
            $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
          } else {
            $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
          }
        } else {
          $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
        }
      }
      $('#ring-box-engraving-info').on('change', function() {
        var selectedValue = this.value;
        var element = $(this).find('option:selected'); 
        var variantPrice = element.attr('data-variant-price');
        if( variantPrice != undefined ) {
          $('.engravings-ringBox').attr('data-product-price', variantPrice);
          _updateProductPrice();
        }
        if (selectedValue == 'Image') {
          $('.ring-box-image-engraving-info-wrapper').show();
          $('.ring-box-text-engraving-info-wrapper').hide();
          $('.ring-box-text-engraving-info-wrapper .text_engraving').val('');
          $('#ring-box-image-engraving-info').prop('required', true);
          $('#ring-box-text-engraving-info').prop('required', false);
        //  disable/enable view ring button when image is upload or not
          $("#ring-box-image-engraving-info").change(function() {            
            if ($(this).prop("files").length > 0) {
              $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable");
            } else {
              $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
            }
          });
          
        } else if(selectedValue == 'Text'){
          $('.ring-box-text-engraving-info-wrapper').show();
          $('.ring-box-image-engraving-info-wrapper').hide();
          $('.ring-box-image-engraving-info-wrapper .image_engraving').val('');
          $('#ring-box-image-engraving-info').prop('required', false);
          $('#ring-box-text-engraving-info').prop('required', true);
        //  disable/enable view ring button when image is upload or not
          $("#ring-box-text-engraving-info").keyup(function() {
            var hasText = $(this).val().trim() !== ""; // Check for non-empty trimmed value
            if (hasText) {
              $(".bottom-nav-add-to-cart-btn > .Click-here").addClass("cart-btn-enable"); // Replace "your-class-name" with your desired class
            } else {
              $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
            }
          });
        } else {
          $('.ring-box-image-engraving-info-wrapper').hide();
          $('.ring-box-text-engraving-info-wrapper').hide();
          $('.ring-box-image-engraving-info-wrapper .image_engraving').val('');
          $('.ring-box-text-engraving-info-wrapper .text_engraving').val('');
          $('#ring-box-image-engraving-info').prop('required', false);
          $('#ring-box-text-engraving-info').prop('required', false);
          $(".bottom-nav-add-to-cart-btn > .Click-here").removeClass("cart-btn-enable");
        }
      });
    } else if(currentOption.attr('name') == 'choose-bandwidth-opt'){
      _updateProductPrice();
      var bandwidthimg = currentOption.next().attr('src');
      $('.main_band_width_product_img').attr('src',bandwidthimg);
    } else if(currentOption.attr('name') == 'choose-finish-opt'){
      _updateProductPrice();
    } else if(currentOption.attr('name') == 'choose-center-stone'){
      var centerStoneimg = currentOption.next().attr('src');
      $('.main_center_stone_img').attr('src',centerStoneimg);
      _updateProductPrice();
      
      // Mobile-specific image slider injection
      if (window.innerWidth <= 767) {
        const productUrl = currentOption.data('product-url');

        $.getJSON(productUrl + '.js', function (product) {
          const images = product.images;
          if (images.length > 0) {
            const sliderHtml = `<div class="center-stone-mobile-ring-slider">` +
              images.map(img => `<div class="slider-item"><img src="${img}" alt="ring slide" /></div>`).join('') +
              `</div>`;

            const $optionWrapper = currentOption.closest('.d-o-p-s-radio-opt');

            // Remove previous sliders and reset hidden images
            $('.d-o-p-s-radio-opt .center-stone-mobile-ring-slider').remove();
            $('.d-o-p-s-radio-opt img.center_stone_product_img').show();

            // Hide static image in current option
            $optionWrapper.find('img.center_stone_product_img').hide();

             // Inject slider before the image
            $optionWrapper.find('img.center_stone_product_img').before(sliderHtml);
            
            $optionWrapper.find('.center-stone-mobile-ring-slider').addClass('loading-slider');
            setTimeout(() => {
              $optionWrapper.find('.center-stone-mobile-ring-slider').slick({
                dots: false,
                arrows: true,
                fade: true,
                cssEase: 'ease-in-out',
                autoplay: true,
                autoplaySpeed: 1500,
                slidesToShow: 1,
                adaptiveHeight: true
              });
              $optionWrapper.fadeIn(200);
              $optionWrapper.find('.center-stone-mobile-ring-slider').removeClass('loading-slider');
            }, 100);

          }
        });
      }

      var productUrl = currentOption.data('product-url');
      // Fetch product details from Shopify's API
      $.getJSON(productUrl + '.js', function (product) {
          const images = product.images; // Array of image URLs
          if (images.length > 0) {
              // Create slider content
              const sliderContent = images.map((image, index) => `
                  <div class="slider-item">
                      <img src="${image}" alt="Center Stone Image ${index + 1}" />
                  </div>
              `).join('');

              // Update main_center_stone_img div
              const $mainDiv = $('.center_stone_img');
              $mainDiv.addClass('loading-slider');

              // Destroy existing Slick instance if initialized
              if ($mainDiv.find('.center-stone-slider').hasClass('slick-initialized')) {
                $mainDiv.find('.center-stone-slider').slick('unslick');
              }

              // $mainDiv.html(`<div class="center-stone-slider">${sliderContent}</div>`);
              $mainDiv.html(`<div class="center-stone-slider" style="display:none;">${sliderContent}</div>`);
              // Initialize Slick Slider
              setTimeout(() => {
                slickCenterSton();
                $mainDiv.find('.center-stone-slider').fadeIn(200);
                $mainDiv.removeClass('loading-slider');
              }, 100);

          } else {
              console.error('No images available for the selected center stone.');
          }
      }).fail(function () {
          console.error('Failed to fetch product data.');
      });
    } else if(currentOption.attr('name') == 'choose-accent-stone'){
      _updateProductPrice();
      var accentStoneimg = currentOption.next().attr('src');
      $('.main_accent_stone_img').attr('src',accentStoneimg);
    } else if(currentOption.attr('name') == 'ring-size-opt'){
      
      if (currentOption.val() == 'Select Size') {
        parentDiv.find('input[name="ring-size-opt"]').prop('checked', false);
        setTimeout(() => {
          $('.sub-toatal-fixed-bottom-part .steps').find('.step.next-step').removeClass('disabled').addClass('disabled');
        }, 10);
      } else {
        $('.sub-toatal-fixed-bottom-part .steps').find('.step').removeClass('disabled');
        if (currentTarget.find('input[name="ring-size-opt"]').length > 0) {
          if(currentTarget.find('input[name="ring-size-opt"]').is(':checked')){
            parentDiv.find('select[name="ring-size-opt"]').prop('selectedIndex', 0);
          }
        } else {
            parentDiv.find('input[name="ring-size-opt"]').prop('checked', false);
        }
        _updateProductPrice();
      }
    }
    if(parentDiv.next('.dopsTabContent').length !== 0){
      $('.custom_ring_add').addClass('hide');
    }else {
      $('.custom_ring_add').removeClass('hide');
    }
  });


});

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CustomRingForm extends HTMLElement {
  
  constructor() {
    super();   
  
    this.form = this.querySelector('form');
    this.querySelector('[data-action="custom-add-to-cart"]').addEventListener('click',this._addToCart.bind(this));
    // this.delegateElement.on('click', '[data-action="custom-add-to-cart"]', this._addToCart.bind(this));
  }
  
  _addToCart(event) {
    event.preventDefault(); // Prevent form from being submitted
    var _this4 = this;
    Shopify.queue = [];
    const properties = {};
    let randomNo = Math.floor(Math.random() * 10000);
    var myElem = document.querySelector('.custom-ring-form');
    var addToCartButton = this.querySelector('.custom_ring_add');
    addToCartButton.setAttribute('disabled', true);
    addToCartButton.classList.add('loading');
  
    var formElement = this.querySelector('.customring_form');
    var formData = new FormData(formElement); // Create FormData object

    var variantId = formData.get('id'); // Get the variant ID from the form data
    var quantity = 1;
    
    if (myElem !== null) {
      properties._random_no = randomNo;
    }
  
    // Pass all properties from product to the cart line items
    for (const [name, value] of formData.entries()) {
      if (name.startsWith('properties[')) {
        const propertyName = name.replace('properties[', '').replace(']', '');
        properties[propertyName] = value;
      }
    }

    // get the men's and women's custom ring variant ID
    var defaultSelectedVariantId = document.querySelector('.custom-ring-form .customring_form [name="id"]').value;

    // get all the selected radio button value
    var ringProduct = document.querySelector('input[name="choose-ring-opt"]:checked');
    var ringProductVariant = document.querySelector('input[name="band-color-opt"]:checked');
    var inlayProduct = document.querySelector('input[name="choose-inlay-opt"]:checked');
    var inlayProduct2 = document.querySelector('input[name="choose-inlay-opt-2"]:checked');
    var inlayProduct3 = document.querySelector('input[name="choose-inlay-opt-3"]:checked');
    var bandWidthProduct = document.querySelector('input[name="choose-bandwidth-opt"]:checked');
    var freeRingSizeProduct;
    if(document.querySelector('input[name="ring-size-opt"]:checked')){
     freeRingSizeProduct = document.querySelector('input[name="ring-size-opt"]:checked'); 
    }else {
      freeRingSizeProduct = document.querySelector('select[name="ring-size-opt"]');
    }
    
    var finishProduct = document.querySelector('input[name="choose-finish-opt"]:checked');
    var engravingProduct = document.querySelector('input[name="choose-engravings-opt"]:checked');
    var ringBoxEngravingProduct = document.querySelector('input[name="choose-ring-box-engravings-opt"]:checked')
    var centerStone = document.querySelector('input[name="choose-center-stone"]:checked');
    var accentStone = document.querySelector('input[name="choose-accent-stone"]:checked');
    var addRushProduct = document.querySelector('input[name="add_rush_product"]:checked');
    var cadProduct = document.querySelector('input[name="add_cad_product"]');
    
    if (ringProduct != null) {
      var selectedRingProductProducts = ringProduct.getAttribute('data-variant-id');
      properties.ring_product = ringProduct.value;
    }

    if (ringProductVariant != null) {
      var selectedRingProductVariantProducts = ringProductVariant.getAttribute('data-variant-id');
      properties.ring_product_variant = ringProductVariant.value;
    }

    if (inlayProduct != null && inlayProduct.value != 'Send in my own materials') {
      var selectedInlayProductProducts = inlayProduct.getAttribute('data-variant-id');
      properties.inlay_product = inlayProduct.value;
      if (document.querySelector('.inlay_info textarea[name="inlay-order-info"]').value != '' ) {
        properties.inlay_product_info = document.querySelector('.inlay_info textarea[name="inlay-order-info"]').value;
      }
    } else if (inlayProduct != null && inlayProduct.value == 'Send in my own materials') {
      var selectedInlayProductProducts = inlayProduct.getAttribute('data-variant-id');
      properties.inlay_product = inlayProduct.value;
      properties.inlay_own_material = document.querySelector('.own-material-info-wrapper textarea[name="inlay-material-info"]').value; 
      if (document.querySelector('.inlay_info textarea[name="inlay-material-info"]').value != '' ) {
        properties.inlay_product_info = document.querySelector('.inlay_info textarea[name="inlay-order-info"]').value;
      }
    }

    if (inlayProduct2 != null && inlayProduct2.value != 'Send in my own materials') {
      var selectedInlayProductProducts2 = inlayProduct2.getAttribute('data-variant-id');
      properties.inlay_product2 = inlayProduct2.value;
      if (document.querySelector('.inlay_info textarea[name="inlay-order-info-2"]').value != '' ) {
        properties.inlay_product_info2 = document.querySelector('.inlay_info textarea[name="inlay-order-info-2"]').value;
      }
    } else if (inlayProduct2 != null && inlayProduct2.value == 'Send in my own materials') {
      var selectedInlayProductProducts2 = inlayProduct2.getAttribute('data-variant-id');
      properties.inlay_product2 = inlayProduct2.value;
      properties.inlay_own_material = document.querySelector('.own-material-info-wrapper textarea[name="inlay-material-info"]').value; 
      if (document.querySelector('.inlay_info textarea[name="inlay-material-info"]').value != '' ) {
        properties.inlay_product_info2 = document.querySelector('.inlay_info textarea[name="inlay-order-info-2"]').value;
      }
    }

    if (inlayProduct3 != null && inlayProduct3.value != 'Send in my own materials') {
      var selectedInlayProductProducts3 = inlayProduct3.getAttribute('data-variant-id');
      properties.inlay_product3 = inlayProduct3.value;
      if (document.querySelector('.inlay_info textarea[name="inlay-order-info-3"]').value != '' ) {
        properties.inlay_product_info3 = document.querySelector('.inlay_info textarea[name="inlay-order-info-3"]').value;
      }
    } else if (inlayProduct3 != null && inlayProduct3.value == 'Send in my own materials') {
      var selectedInlayProductProducts3 = inlayProduct3.getAttribute('data-variant-id');
      properties.inlay_product3 = inlayProduct3.value;
      properties.inlay_own_material = document.querySelector('.own-material-info-wrapper textarea[name="inlay-material-info"]').value; 
      if (document.querySelector('.inlay_info textarea[name="inlay-order-info-2"]').value != '' ) {
        properties.inlay_product_info3 = document.querySelector('.inlay_info textarea[name="inlay-order-info-3"]').value;
      }
    }

    if (bandWidthProduct != null) {
      var selectedBandwidthProducts = bandWidthProduct.getAttribute('data-variant-id');
      properties.bandwidth_product = bandWidthProduct.value;
    }

    if (freeRingSizeProduct != null && freeRingSizeProduct.value == 'SELECT FREE SIZING KIT') {
      var selectedFreeRingSizeProducts = freeRingSizeProduct.getAttribute('data-variant-id');
      properties.ring_size = freeRingSizeProduct.value;
    } else if (freeRingSizeProduct != null && freeRingSizeProduct.value != 'SELECT FREE SIZING KIT') {
      properties.ring_size = freeRingSizeProduct.value;
    }

    if (finishProduct != null) {
      var selectedFinishProducts = finishProduct.getAttribute('data-variant-id');
      properties.finish_product = finishProduct.value;
    }

    if (engravingProduct != null) {
      var selectedEngravingProducts = engravingProduct.getAttribute('data-variant-id');
      properties.engraving_product = engravingProduct.value;
      if (engravingProduct.value == 'Image Engraving') {
        const imageInput = document.getElementById('image-engraving-info');
        if (imageInput.files.length > 0) {
          properties.engraving_product_image_engraving = imageInput.files[0];
        }
      } else if (engravingProduct.value == 'Text Engraving') {
        const textInput = document.getElementById('text-engraving-info');
        if (textInput.value != '') {
          properties.engraving_product_text_engraving = textInput.value;
        }
      }
    }
    if (ringBoxEngravingProduct != null) {
      var chooseRingBoxEngravingsOpt = ringBoxEngravingProduct.value;
    }
    if (centerStone != null) {
      var selectedCenterStoneProducts = centerStone.getAttribute('data-variant-id');
      properties.center_stone = centerStone.value; 
    }
    if (accentStone != null) {
      var selectedAccentStoneProducts = accentStone.getAttribute('data-variant-id');
      properties.accent_stone = accentStone.value;
    }
    if (addRushProduct != null) {
      $('.rush_date').show();
      var dateValue = $('#add_rush_product_delivery_Date').val();
      if (dateValue != '') {
       properties.delivery_date =  dateValue;
      }
      var selectedAddRushProducts = addRushProduct.getAttribute('data-variant-id');
      properties.add_rush = addRushProduct.value;
    }
    if (cadProduct != null) {
      var selectedAddCadProducts = cadProduct.getAttribute('data-variant-id');
      properties.add_cad = cadProduct.value;
    }

    if (chooseRingBoxEngravingsOpt != undefined ) {
      var boxEngraving = document.getElementById("ring-box-engraving-info");
      var boxEngravingValue = boxEngraving.value;
      var boxEngravingText = boxEngraving.options[boxEngraving.selectedIndex].text;
      var selectedboxEngravingProducts = boxEngraving.options[boxEngraving.selectedIndex].getAttribute('data-variant-id');
      if ( boxEngravingValue != 'Choose Text Or Image Engraving') {
        properties.ringBoxEngravings = `${boxEngravingValue} Ring Box Engravings`;
      }
      
      if (boxEngravingValue == 'Image') {
        const boxImageInput = document.getElementById('ring-box-image-engraving-info');
        if (boxImageInput.files.length > 0) {
          properties.ringbox_image_engraving = boxImageInput.files[0];
        }
      } else if (boxEngravingValue == 'Text') {
        const boxTextInput = document.getElementById('ring-box-text-engraving-info');
        if (boxTextInput.value != '') {
          properties.ringbox_text_engraving = boxTextInput.value;
        }
      }
    }

    // get selected Ring product variant id and push it in the shopify queue
      if (selectedRingProductProducts != null || selectedRingProductProducts != undefined ) {
        const defaultRingProduct = {};
        defaultRingProduct._random_no = randomNo;
        defaultRingProduct._type = 'Custom ring bundle Product';
        defaultRingProduct._producttype = 'Ring Product';
        Shopify.queue.push({
          variantId: selectedRingProductProducts,
          properties: defaultRingProduct,
          quantity,
        });
      }

    // get selected Ring product variant id and push it in the shopify queue
      if (selectedRingProductVariantProducts != null || selectedRingProductVariantProducts != undefined ) {
        const defaultRingProductVariant = {};
        defaultRingProductVariant._random_no = randomNo;
        defaultRingProductVariant._type = 'Custom ring bundle Product';
        defaultRingProductVariant._producttype = 'Ring Product Variant';
        Shopify.queue.push({
          variantId: selectedRingProductVariantProducts,
          properties: defaultRingProductVariant,
          quantity,
        });
      }
  
    // get selected Inlay product variant id and push it in the shopify queue
      if (selectedInlayProductProducts != null || selectedInlayProductProducts != undefined ) {
        const defaultInlayProduct = {};
        defaultInlayProduct._random_no = randomNo;
        defaultInlayProduct._type = 'Custom ring bundle Product';
        defaultInlayProduct._producttype = 'Inlay Product 1';
        Shopify.queue.push({
          variantId: selectedInlayProductProducts,
          properties: defaultInlayProduct,
          quantity,
        });
      }
  
    // get selected Inlay product variant id and push it in the shopify queue
      if (selectedInlayProductProducts2 != null || selectedInlayProductProducts2 != undefined ) {
        const defaultInlayProduct = {};
        defaultInlayProduct._random_no = randomNo;
        defaultInlayProduct._type = 'Custom ring bundle Product';
        defaultInlayProduct._producttype = 'Inlay Product 2';
        Shopify.queue.push({
          variantId: selectedInlayProductProducts2,
          properties: defaultInlayProduct,
          quantity,
        });
      }
  
    // get selected Inlay product variant id and push it in the shopify queue
      if (selectedInlayProductProducts3 != null || selectedInlayProductProducts3 != undefined ) {
        const defaultInlayProduct = {};
        defaultInlayProduct._random_no = randomNo;
        defaultInlayProduct._type = 'Custom ring bundle Product';
        defaultInlayProduct._producttype = 'Inlay Product 3';
        Shopify.queue.push({
          variantId: selectedInlayProductProducts3,
          properties: defaultInlayProduct,
          quantity,
        });
      }

    // get selected Bandwidth product variant id and push it in the shopify queue
      if (selectedBandwidthProducts != null || selectedBandwidthProducts != undefined ) {
        const defaultBandwidthProduct = {};
        defaultBandwidthProduct._random_no = randomNo;
        defaultBandwidthProduct._type = 'Custom ring bundle Product';
        defaultBandwidthProduct._producttype = 'Bandwidth Product';
        Shopify.queue.push({
          variantId: selectedBandwidthProducts,
          properties: defaultBandwidthProduct,
          quantity,
        });
      }

    // get selected Finish product variant id and push it in the shopify queue
      if (selectedFinishProducts != null || selectedFinishProducts != undefined ) {
        const defaultFinishProduct = {};
        defaultFinishProduct._random_no = randomNo;
        defaultFinishProduct._type = 'Custom ring bundle Product';
        defaultFinishProduct._producttype = 'Finish Product';
        Shopify.queue.push({
          variantId: selectedFinishProducts,
          properties: defaultFinishProduct,
          quantity,
        });
      }

    // get selected Free Ring Size product variant id and push it in the shopify queue
      if (selectedFreeRingSizeProducts != null || selectedFreeRingSizeProducts != undefined ) {
        const defaultFreeRingSizeProduct = {};
        defaultFreeRingSizeProduct._random_no = randomNo;
        defaultFreeRingSizeProduct._type = 'Custom ring bundle Product';
        defaultFreeRingSizeProduct._producttype = 'Free Ring Size Product';
        Shopify.queue.push({
          variantId: selectedFreeRingSizeProducts,
          properties: defaultFreeRingSizeProduct,
          quantity,
        });
      }

    // get selected Engraving product variant id and push it in the shopify queue
      if (selectedEngravingProducts != null || selectedEngravingProducts != undefined ) {
        const defaultEngravingProduct = {};
        defaultEngravingProduct._random_no = randomNo;
        defaultEngravingProduct._type = 'Custom ring bundle Product';
        defaultEngravingProduct._producttype = 'Engraving Product';
        Shopify.queue.push({
          variantId: selectedEngravingProducts,
          properties: defaultEngravingProduct,
          quantity,
        });
      }
    
    // get selected Ring Box Engraving product variant id and push it in the shopify queue
      if (selectedboxEngravingProducts != null || selectedboxEngravingProducts != undefined ) {
        const defaultRingBoxEngravingProduct = {};
        defaultRingBoxEngravingProduct._random_no = randomNo;
        defaultRingBoxEngravingProduct._type = 'Custom ring bundle Product';
        defaultRingBoxEngravingProduct._producttype = 'Ring Box Engraving Product';
        Shopify.queue.push({
          variantId: selectedboxEngravingProducts,
          properties: defaultRingBoxEngravingProduct,
          quantity,
        });
      }

    // get selected Center stone product variant id and push it in the shopify queue
      if (selectedCenterStoneProducts != null || selectedCenterStoneProducts != undefined ) {
        const defaultCenterStoneProduct = {};
        defaultCenterStoneProduct._random_no = randomNo;
        defaultCenterStoneProduct._type = 'Custom ring bundle Product';
        defaultCenterStoneProduct._producttype = 'Center Stone';
        Shopify.queue.push({
          variantId: selectedCenterStoneProducts,
          properties: defaultCenterStoneProduct,
          quantity,
        });
      }

    // get selected Accent stone product variant id and push it in the shopify queue
      if (selectedAccentStoneProducts != null || selectedAccentStoneProducts != undefined ) {
        const defaultAccentStoneProduct = {};
        defaultAccentStoneProduct._random_no = randomNo;
        defaultAccentStoneProduct._type = 'Custom ring bundle Product';
        defaultAccentStoneProduct._producttype = 'Accent Stone';
        Shopify.queue.push({
          variantId: selectedAccentStoneProducts,
          properties: defaultAccentStoneProduct,
          quantity,
        });
      }

    // get selected Rush product variant id and push it in the shopify queue
      if (selectedAddRushProducts != null || selectedAddRushProducts != undefined ) {
        const defaultRushProduct = {};
        defaultRushProduct._random_no = randomNo;
        defaultRushProduct._type = 'Custom ring bundle Product';
        defaultRushProduct._producttype = 'Rush Product';
        Shopify.queue.push({
          variantId: selectedAddRushProducts,
          properties: defaultRushProduct,
          quantity,
        });
      }

    // get selected Rush product variant id and push it in the shopify queue
      if (selectedAddCadProducts != null || selectedAddCadProducts != undefined ) {
        const defaultCadProduct = {};
        defaultCadProduct._random_no = randomNo;
        defaultCadProduct._type = 'Custom ring bundle Product';
        defaultCadProduct._producttype = 'CAD design Product';
        Shopify.queue.push({
          variantId: selectedAddCadProducts,
          properties: defaultCadProduct,
          quantity,
        });
      }

    Shopify.queue.push({
      variantId,
      properties,
      quantity,
    });

    Shopify.moveAlong = function() {
      if (Shopify.queue.length) {
        const request = Shopify.queue.shift();
        
        const formData = new FormData();
        formData.append('form_type', 'product');
        formData.append('id', request.variantId);
        formData.append('quantity', request.quantity);
        
        for (const key in request.properties) {
          formData.append(`properties[${key}]`, request.properties[key]);
        }


        fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: formData,
          credentials: 'same-origin',
          method: 'POST'
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          var quantityElement = formElement.querySelector('[name="quantity"]');
            if (response.ok) {
              addToCartButton.classList.remove('loading');
              addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
              $(".close-btn, .bg-overlay").click();

              _this4.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: _this4.currentVariant,
                  quantity: quantityElement ? parseInt(quantityElement.value) : 1
                }
              }));
              Shopify.moveAlong();
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });              
            }
  
        });
      } else {
        addToCartButton.setAttribute('disabled', true);
      }
    };
    
    Shopify.moveAlong();
    
  }
}
customElements.define('custom-ring-form', CustomRingForm);









// STEP NAVIGATION MENU ITEM COUNT & ADD CLASS REMOVE CLASS



$(document).ready(function() {
  $('.design-own-product-steps .steps ul').each(function() {
    var liCount = $(this).find('li').length;
    var wordMap = {
      1: "one",
      2: "two",
      3: "three",
      4: "four",
      5: "five",
      6: "six",
      7: "seven",
      8: "eight",
      9: "nine",
      10: "ten"
    };

    // Use the wordMap to get the word equivalent of liCount
    var word = wordMap[liCount] || liCount; // Use liCount if not found in map

    $(this).addClass(word + '-items');
  });

  $(".Click-here").on('click', function() {
    $(".custom-model-main").addClass('model-open');
    Array.from(document.querySelectorAll('.d-o-p-s-content-body .d-o-p-s-radio-opt .input-radio-opt:checked, .d-o-p-s-radio-opt select.input-radio-opt')).forEach(function(checkedRadio) {
      
      var currencyFormat = window.themeVariables.currencyCodeEnabled ? window.themeVariables.moneyWithCurrencyFormat : window.themeVariables.moneyFormat;
      var selectedProductvalue = checkedRadio.value;
      if(checkedRadio.type == "select-one") checkedRadio = checkedRadio.options[checkedRadio.selectedIndex]
      var ProductImage = checkedRadio.nextElementSibling ? checkedRadio.nextElementSibling.getAttribute('src') : '';
      var selectedProductPrice = checkedRadio.getAttribute('data-product-price');
      var selectedProductURL = checkedRadio.getAttribute('data-product-url');
      var formatedChildPrice = Currency.formatMoney(selectedProductPrice, currencyFormat);
      var selectedProductTitle = checkedRadio.getAttribute('data-product-name');
      let selectedProductImage;
      if(ProductImage != null) {
        selectedProductImage = ProductImage;
      } else {
        selectedProductImage = 'https://cdn.shopify.com/s/files/1/0252/9588/0271/files/Logo_1.png?v=1720538597';
      }
      var html = `<div class="CartItem">
        <div class="CartItem__ImageWrapper AspectRatio"><div class="AspectRatio" style="--aspect-ratio: 1.0">
        <img class="CartItem__Image" src="${selectedProductImage}" alt="${selectedProductvalue}">
        </div></div>
        <div class="CartItem__Info"><h2 class="CartItem__Title Heading">
        <a>${selectedProductTitle}</a>
        </h2></div>
        <div class="CartItem__LinePriceList Heading Text--subdued" style="text-align: right">
        <span class="CartItem__Price Price">${formatedChildPrice}</span>
        </div>
        </div>`;
        document.querySelector(".pop-up-content-wrap .Cart__ItemList").insertAdjacentHTML(
            'beforeend', 
            html
        );
    });
    $('input[name="accept_terms"]').change(function() {
        if(this.checked) {
          $('[data-action="custom-add-to-cart"]').prop('disabled', false);
        } else {
          $('[data-action="custom-add-to-cart"]').prop('disabled', true);
        }
    });
    if(document.querySelector('input[name="choose-center-stone"]') != null) {
      var selectedProductStandardStone = document.querySelector('input[name="choose-center-stone"]:checked').getAttribute('data-standard-stone');
      if (selectedProductStandardStone == 'yes') {
        $('.accept_stone_image_condition').addClass('d-block').removeClass('d-none');
        $('input[name="accept_stone_image"]').change(function() {
          if(this.checked) {
            $('[data-action="custom-add-to-cart"]').prop('disabled', false);
          } else {
            $('[data-action="custom-add-to-cart"]').prop('disabled', true);
          }
        });
      } else {
        $('.accept_stone_image_condition').addClass('d-none').removeClass('d-block');
        document.getElementById("accept_stone_image").checked = false;
      }
    }
    $('input[name="add_rush_product"]').change(function() {
        if(this.checked) {
          $('.rush_date').show();
        } else {
          $('.rush_date').hide();
        }
    });
  }); 


  
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
    $('[data-action="custom-add-to-cart"]').prop('disabled', false);
    if ('input[name="add_rush_product"]:checked') {
      $('input[name="add_rush_product"]').prop('disabled', false);
      $('input[name="add_rush_product_delivery_Date"]').text('');
    }
    Array.from(document.querySelectorAll('.pop-up-content-wrap .CartItem')).forEach(function(allcartitem) {
      allcartitem.remove();
    });
  });

});




  $('.d-o-p-s-content-body input[type="radio"]').on('change', function() {
    // Get the selected radio button value
    var selectedValue = $(this).val();
    
    // Find all UL elements within the form or within a specific container if needed
    var ulElements = $('.design-own-product-steps .steps ul') // adjust selector if needed;
    
    // Iterate over each UL element
    setTimeout(function(){
    ulElements.each(function() {
      var listElement = $(this); // Store the current UL element for efficiency
      
      // Filter visible LI elements with the specified class: "li.step:not(.d-none)"
      var visibleStepItems = listElement.find('li.step:not(.d-none)');

      // Clear any existing classes related to item count
      listElement.removeClass('one-items two-items three-items four-items five-items six-items seven-items eight-items nine-items');
      

      // Apply class based on the number of visible items
      switch (visibleStepItems.length) {
        case 1:
          listElement.addClass('one-items');
          break;
        case 2:
          listElement.addClass('two-items');
          break;
        case 3:
          listElement.addClass('three-items');
          break;
        case 4:
          listElement.addClass('four-items');
          break;
        case 5:
          listElement.addClass('five-items');
          break;
        case 6:
          listElement.addClass('six-items');
          break;
        case 7:
          listElement.addClass('seven-items');
          break;
        case 8:
          listElement.addClass('eight-items');
          break;
        case 9:
          listElement.addClass('nine-items');
          break;
      }


      // Remove any existing "last-step" class
    listElement.find('li.last-step').removeClass('last-step');

    // Add "last-step" class to the last visible LI element
    visibleStepItems.last().addClass('last-step');
    });
    },300);
  });

  // Initialize the last index for products
// function initializeLastIndex() {
//   window.lastProductIndex = $('.center-stone-box').length;
// }

// Infinite Scroll Implementation
// function infiniteScroll() {
//   $(window).on('scroll', function() {
//     // console.log($(window).height(), '=======>height');
//     // console.log($(window).scrollTop(), '=======>$(window).scrollTop()');
//     // console.log($(window).scrollTop() + $(window).height(), '=======>$(window).scrollTop() + $(window).height()');
    
//     // console.log($(document).height(), '=======>$(document).height()');
//     // console.log($(document).height() - $(window).height(), '=======>$(document).height() - $(window).height()');
    
    
//       if ($(window).scrollTop() + $(window).height() >= $(document).height() - $(window).height()) {
//           const loadMoreButton = $('[data-load-more]');
//           if (loadMoreButton.length) {
//               loadMoreButton.trigger('click');
//           }
//       }
//   });
// }

// function infiniteScroll() {
//     const loadMoreButton = document.querySelector('.pagination-button__load-more');
//     if (!loadMoreButton) return;

//     const observer = new IntersectionObserver(
//         (entries) => {
//             entries.forEach((entry) => {
//                 if (entry.isIntersecting) {
//                     loadMoreProducts(loadMoreButton);
//                 }
//             });
//         },
//         { rootMargin: '200px' } // Adjust as needed to pre-load content before reaching the bottom
//     );

//     observer.observe(loadMoreButton);
// }

// function loadMoreProducts(button) {
//   const nextPageURL = button.getAttribute('href');
//   if (!nextPageURL) return;

//   // Prevent multiple requests by disabling the button temporarily
//   button.setAttribute('disabled', 'true');
//   button.classList.add('loading');

//   fetch(nextPageURL)
//       .then((response) => response.text())
//       .then((html) => {
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');

//           const newItems = doc.querySelectorAll('.stone-item');
//           const gridContainer = document.querySelector('#centerStoneItems');

//           // Append new items to the grid and update IDs dynamically
//           newItems.forEach((item) => {
//               lastIndex++; // Increment the index
//               const inputElement = item.querySelector('input[type="radio"]');
//               const labelElement = item.querySelector('label');

//               if (inputElement) {
//                   inputElement.id = `center-stone-opt-${lastIndex}`;
//               }
//               if (labelElement) {
//                   labelElement.setAttribute('for', `center-stone-opt-${lastIndex}`);
//               }

//               gridContainer.appendChild(item);
//           });

//           // Reinitialize filters to include new items
//           initializeFilters();

//           // Update the "Load More" button or hide it if no more pages
//           const newPaginationButton = doc.querySelector('.pagination-button__load-more');
//           if (newPaginationButton) {
//               button.setAttribute('href', newPaginationButton.getAttribute('href'));
//               button.removeAttribute('disabled');
//               button.classList.remove('loading');
//           } else {
//               button.style.display = 'none';
//               observer.disconnect(); // Stop observing if no more pages
//           }
//       })
//       .catch((error) => {
//           console.error('Error loading more products:', error);
//           button.removeAttribute('disabled');
//           button.classList.remove('loading');
//       });
// }

  // Apply Filters
function initializeFilters() {
  $('#stoneTypeFilter, #stoneCutFilter, #stoneColorFilter').on('change', function() {
      applyFilters();
      setTimeout(() => {
        highlightFirstVisibleStoneItem(); // Ensure the function is called after DOM changes.
      }, 0);
  });
}

// Highlight the first visible center stone item
function highlightFirstVisibleStoneItem() {
  const firstVisibleItem = $('.center-stone-box:visible').first();
  if (firstVisibleItem.length) {
    firstVisibleItem.find('.input-radio-opt').click();
  }
}

let lastIndex = 0; // To keep track of the last product index
function initializeLastIndex() {
    const allItems = document.querySelectorAll('[id^="center-stone-opt-"]'); // Select all elements with IDs starting with "center-stone-opt-"
    if (allItems.length > 0) {
        // Extract the numeric part of each ID and find the maximum value
        lastIndex = Array.from(allItems)
            .map((item) => {
                const match = item.id.match(/center-stone-opt-(\d+)/);
                return match ? parseInt(match[1], 10) : 0;
            })
            .reduce((max, current) => Math.max(max, current), 0);
    }
}

// Load More Products Functionality
function loadMoreProducts() {
  $(document).on('click', '[data-load-more]', function(e) {
      e.preventDefault();
      const loadMoreButton = $(this);
      const nextPageURL = loadMoreButton.attr('href');
      if (!nextPageURL) return;

      // Prevent multiple requests by disabling the button temporarily      
      loadMoreButton[0].setAttribute('disabled', 'true');
      loadMoreButton[0].classList.add('d-none');
      $('.loader-img').addClass('d-block').removeClass('d-none');
  
      fetch(nextPageURL)
          .then((response) => response.text())
          .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
  
              const newItems = doc.querySelectorAll('.stone-item');
              const gridContainer = document.querySelector('#centerStoneItems');
  
              // Append new items to the grid and update IDs dynamically
              newItems.forEach((item) => {
                  lastIndex++; // Increment the index
                  const inputElement = item.querySelector('input[type="radio"]');
                  const labelElement = item.querySelector('label');
  
                  if (inputElement) {
                      inputElement.id = `center-stone-opt-${lastIndex}`;
                  }
                  if (labelElement) {
                      labelElement.setAttribute('for', `center-stone-opt-${lastIndex}`);
                  }
  
                  gridContainer.appendChild(item);
              });
  
              // Update the "Load More" button or hide it if no more pages
              const newPaginationButton = doc.querySelector('.pagination-button__load-more');
              if (newPaginationButton) {
                  loadMoreButton[0].setAttribute('href', newPaginationButton.getAttribute('href'));
                  loadMoreButton[0].removeAttribute('disabled');
                  loadMoreButton[0].classList.remove('d-none');
                  $('.loader-img').addClass('d-none').removeClass('d-block');
  
                  // Reinitialize filters to include new items
                  initializeFilters();
                  applyFilters();
              } else {
                  loadMoreButton[0].style.display = 'none';
                  observer.disconnect(); // Stop observing if no more pages
              }
          })
          .catch((error) => {
              console.error('Error loading more products:', error);
              button.removeAttribute('disabled');
              button.classList.remove('loading');
          });
  });
}

function applyFilters() {
  const selectedType = $('#stoneTypeFilter').val();
  const selectedCut = $('#stoneCutFilter').val();
  const selectedColor = $('#stoneColorFilter').val();

  $('.center-stone-box').each(function() {
      const stoneType = $(this).data('stone-type');
      const stoneCut = $(this).data('stone-cut');
      const stoneColor = $(this).data('stone-color');

      const typeMatch = selectedType === 'Stone Type_all' || stoneType.includes(selectedType.replace('Stone Type_', ''));
      const cutMatch = selectedCut === 'Stone Cut_all' || stoneCut.includes(selectedCut.replace('Stone Cut_', ''));
      const colorMatch = selectedColor === 'Stone Color_all' || stoneColor.includes(selectedColor.replace('Stone Color_', ''));
      
      if (typeMatch && cutMatch && colorMatch) {
          $(this).show();
      } else {
          $(this).hide();
      }
  });
}

$(document).ready(function() {
  initializeLastIndex();
  initializeFilters();
  loadMoreProducts();

  $('.moblie-ring-step-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 6000
  });
});

// For the issue of the search bar kicking you out while typing, forces focus on fast simon text box

document.addEventListener('focusin', (e) => {
  const search = document.querySelector('header-search');

  if (!search) return;
  if (search.contains(e.target) &&
      e.target.matches('.header-search__input')) {
    search.dataset.focusLocked = 'true';
  }
});

document.addEventListener('focusout', (e) => {
  const search = document.querySelector('header-search');

  if (!search) return;

  setTimeout(() => {
    search.dataset.focusLocked = 'false';
  }, 0);
});

document.addEventListener('focusin', (e) => {
  const search = document.querySelector('header-search');

  if (!search?.dataset.focusLocked) return;

  if (!search.contains(e.target)) return;

  const input = search.querySelector('.header-search__input');

  if (document.activeElement !== input) {
    requestAnimationFrame(() => input?.focus());
  }
}, true);